/*****************************************
 * UI constants
 *****************************************/

export const uiData = {
  // select example text
  selectExample: ["ללא רעש", "עם רעש"],
  selectRate: ["בקר מהיר", "בקר איטי"],

  // slider for Ki
  sliderTitle: "מקדם אינטגרציה",
  sliderMin: 0.1,
  sliderMax: 2.1,
  sliderStep: 0.2,

  // clickable buttons with value
  buttons: [
    {
      text: "צעד אחד",
      value: "step",
    },
  ],

  // colors: ['#00426F', '#65C3A4', '#5765AE', '#59926E', '#453f78', '#30A3B0'],
};

/*****************************************
 * Examples constants and global variables
 *****************************************/

const data = {
  examples: [
    {
      headerText: `ללא רעש`,
      subHeaderText: [""],
      numOfPoints: 20,
      speedArr: [90, 130, 90, 40, 80 , 120],
      PV: 50,
      Kp: 0.2,
      // Ki: 1,
      Kd: 1,
      yMax: 160,
      yMin: 40,
      xLabel: "זמן",
      yLabel: "מהירות הנסיעה",
      noiseRatio: 0,
      interval: 200, // run speed
    },
    {
    headerText: `עם רעש`,
      subHeaderText: [""],
      numOfPoints: 20,
      speedArr: [90, 130, 90, 40, 80 , 120],
      PV: 50,
      Kp: 0.2,
      // Ki: 1,
      Kd: 1,
      yMax: 160,
      yMin: 40,
      xLabel: "זמן",
      yLabel: "מהירות הנסיעה",
      noiseRatio: 15,
      interval: 200, // run speed
    }
    
  ],

  /*****************************************
   * Global variables
   *****************************************/

  exampleIdx: 0,
  lastExampleIdx: -1,

  // canvas grid size
  size: {
    width: 300,
    height: 500,
  },

  state: "new",

  // chart settings
  chartTitle: "בקר PID",
  chartLegendLabels: ["מהירות מטרה", "מהירות"],

  // configure the controller
  Dt: 1,
  tmrPV_rate: 1,
  speedChangeRate: 30, // כל כמה דגימות משתנה המהירות
};

export default data;
